import React from "react"
import MapView from "feature/MapView"
import ControlBoard from "feature/ControlBoard"
import { selectState, } from "app/App/redux"
import { connect, useSelector, } from "react-redux"
import CircularProgress from "@material-ui/core/CircularProgress"
import style from "./style.module.scss"

const connector = connect(null, null)

function App () {
  const {
    initializing,
    initialized,
  } = useSelector(selectState)
  return (
    <div className="App">
      <MapView />
      {initializing && (
        <div className={style.loadingCover}>
          <CircularProgress />
        </div>
      )}
      {initialized && (
        <ControlBoard />
      )}
    </div>
  )
}

export default connector(App)
